import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import hoistNonReactStatics from 'hoist-non-react-statics';
import * as params from '../constants/wix-params';
import withAppSettings from './with-app-settings';
import getDisplayName from '../services/get-display-name';
import getLayoutName from '../services/get-layout-name';

const DEFAULT_WIDTH = 1;

export default function withCardBorderWidth(WrappedComponent) {
  const Wrapper = class extends Component {
    static displayName = `WithCardBorderWidth(${getDisplayName(WrappedComponent)})`;

    static propTypes = {
      layoutType: PropTypes.number,
      cardSize: PropTypes.number,
      borderWidthClassic: PropTypes.number,
      borderWidthSmall: PropTypes.number,
      borderWidthMedium: PropTypes.number,
      borderWidthLarge: PropTypes.number,
    };

    render() {
      const {
        layoutType,
        cardSize,
        borderWidthClassic,
        borderWidthSmall,
        borderWidthMedium,
        borderWidthLarge,
        ...otherProps
      } = this.props;
      const layoutName = getLayoutName(layoutType, cardSize);
      let borderWidth;

      switch (layoutName) {
        case 'classic':
          borderWidth = borderWidthClassic;
          break;
        case 'small':
          borderWidth = borderWidthSmall;
          break;
        case 'medium':
          borderWidth = borderWidthMedium;
          break;
        case 'large':
          borderWidth = borderWidthLarge;
          break;
        default:
          borderWidth = DEFAULT_WIDTH;
      }

      return <WrappedComponent borderWidth={_.isNumber(borderWidth) ? borderWidth : DEFAULT_WIDTH} {...otherProps}/>;
    }
  };

  hoistNonReactStatics(Wrapper, WrappedComponent);

  return withAppSettings({
    layoutType: params.LAYOUT_TYPE_PATH,
    cardSize: params.CARD_SIZE_PATH,
    borderWidthClassic: params.BORDER_WIDTH_CLASSIC_PATH,
    borderWidthSmall: params.BORDER_WIDTH_SMALL_PATH,
    borderWidthMedium: params.BORDER_WIDTH_MEDIUM_PATH,
    borderWidthLarge: params.BORDER_WIDTH_LARGE_PATH,
  })(Wrapper);
}



// WEBPACK FOOTER //
// ./app/hoc/with-card-border-width.js